import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { CheckboxControlComponent } from './checkbox-control/checkbox-control.component';
import { RadioGroupComponent }      from './radio-group/radio-group.component';
import { TextEditorComponent }      from './text-editor/text-editor.component';

angular.module('app-lite.shared.controls', [])
  .directive('worCheckboxControl', downgradeComponent({ component: CheckboxControlComponent }) as ng.IDirectiveFactory)
  .directive('worRadioGroup', downgradeComponent({ component: RadioGroupComponent }) as ng.IDirectiveFactory)
  .directive('worTextEditor', downgradeComponent({ component: TextEditorComponent }) as ng.IDirectiveFactory);